import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import Compressor from "compressorjs"
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import HandWorkOrderTable from "./HandWorkOrderTable"
import DeleteModel from "common/deleteModel/deleteModel"
import { exportDataExcel } from "components/Common/ExportData"
import { dateFormat } from "pages/Common"
import ErrorModel from "common/errorModel/errorModel"
import { GetObjByHandWorkCostingStatus, GetObjByHandWorkOrderStatus } from "_mock/Static_data"
import CreateHandWorkOrderModel from "./CreateHandWorkOrderModel"
import CreateHandWorkModel from "pages/HandWork/CreateHandWorkModel"
import HandWorkOrderDetailModel from "./HandWorkOrderDetailModel"
import HandWorkOrderAllDetailModel from "./HandWorkOrderAllDetailModel"
import Select from "react-select";
import { useFormik } from "formik"
import * as Yup from "yup"
import Dropzone from "react-dropzone"
import StitchingStatusChangeWorkersEndTimeSetModel from "pages/HandWork/StitchingStatusChangeWorkersEndTimeSetModel"


const colourStyles = {
  option: (styles, { isDisabled, isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
      color: isFocused ? "#fff" : "#495057",
      cursor: isDisabled ? "not-allowed" : "default",
      padding: "3px 10px",
    }
  },
  control: (styles, { isDisabled }) => {
    const updatedStyles = {
      ...styles,
      border: "1px solid  #ced4da",
      minHeight: "28px",
      padding: "3px 10px",
      fontSize: "12px",
    }
    return updatedStyles
  },
}

const colourStyles1 = {
  option: (styles, { isDisabled, isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
      color: isFocused ? "#fff" : "#495057",
      cursor: isDisabled ? "not-allowed" : "default",
      padding: "3px 10px",
    }
  },
  control: (styles, { isDisabled }) => {
    const updatedStyles = {
      ...styles,
      border: "1px solid #f46a6a",
      minHeight: "28px",
      padding: "3px 10px",
      fontSize: "12px",
    }
    return updatedStyles
  },
}

function HandWorkOrder() {
  document.title = `Hand Work Order | Raja Rani Couture`
  let { pathname } = useLocation()
  const { deleteApi, getApi, postApi, putApi } = useApi()
  // useStates
  const [modal, setModal] = useState(false)
  const [handWorkDetailModal, setHandWorkDetailModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editData, setEditData] = useState(null)
  const [tableData, setTableData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [screenLoad, setScreenLoad] = useState(false)
  const [searchText, setSearchText] = useState("")
  const [isMobile, setisMobile] = useState(window.innerWidth < 768)
  const [displayStart, setDisplayStart] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(20)
  const [userFilter, setUserFilter] = useState(0)
  const [designerFilter, setDesignerFilter] = useState(0)
  const [users, setUsers] = useState([])
  const [designers, setDesigners] = useState([])
  const [dateFilter, setDateFilter] = useState([new Date(), new Date()])
  const [dateDisble, setdateDisble] = useState(false)
  const [totalRecords, setTotalRecords] = useState(0)
  const [TaskTitleTypes, setTaskTitleTypes] = useState(
    (JSON.parse(localStorage?.getItem("authUser")).TaskTitleTypes))
  const [loginId, setLoginId] = useState(
    (JSON.parse(localStorage?.getItem("authUser")).Id))
  const [statusFilter, setStatusFilter] = useState(TaskTitleTypes?.includes("16") ? [1] : TaskTitleTypes?.includes("14") ? [2] : TaskTitleTypes?.includes("17") ? [4] : [1])
  const [designerId, setDesignerId] = useState(0)
  const [handWorkOrderId, setHandWorkOrderId] = useState(0)
  const [categoriesIds, setCategoriesIds] = useState()
  const [handwWorkOrderModal, setHandwWorkOrderModal] = useState(false)
  const [stitchingModal, setStitchingModal] = useState(false)
  const [handworkOrderAllDetailModal, setHandworkOrderAllDetailModal] = useState(false)
  const [formSumitLoading, setformSumitLoading] = useState(false)
  const [stitchingWorkerId, setStitchingWorkerId] = useState({
    label: 'Select Worker',
    value: 0,
  })
  const [stitchingMasterId, setStitchingMasterId] = useState({
    label: 'Select Master',
    value: 0,
  })
  const [stitchingMasters, setStitchingMasters] = useState([])
  const [stitchingWorkers, setStitchingWorkers] = useState([])
  const [isStitchingMasterSelected, setIsStitchingMasterSelected] = useState(false)
  const [isStitchingWorkerSelected, setIsStitchingWorkerSelected] = useState(false)
  const [isStatus, setIsStatus] = useState(false)
  const [uploadImagesModal, setUploadImagesModal] = useState(false)
  const [viewImagesModal, setViewImagesModal] = useState(false)
  const [images, setImages] = useState([])
  const [imagesUrls, setImagesUrls] = useState([])
  const [imagesBase64, setImagesBase64] = useState([])
  const [deleteImages, setDeleteImages] = useState([]);
  const [updateEndDateTimeModal, setUpdateEndDateTimeModal] = useState(false)
  const [handWorkId, setHandWorkId] = useState(0)

  useEffect(() => {
    getApi('Common/stitching-worker-lookup').then(({ data, status }) => {
      if (status === 200) {
        let options = data.map((item) => ({
          label: item.Value,
          value: item.Key,
        }));
        options.unshift({
          label: "Select Worker",
          value: 0,
        }
        );
        setStitchingWorkerId(options[0])
        setStitchingWorkers(options)
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
    })
    getApi('Common/stitching-master-lookup').then(({ data, status }) => {
      if (status === 200) {
        let options = data.map((item) => ({
          label: item.Value,
          value: item.Key,
        }));
        options.unshift({
          label: "Select Master",
          value: 0,
        });
        setStitchingMasterId(options[0])
        setStitchingMasters(options)
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
    })
  }, [])

  // filter data for user
  const filterData = textFilter => {
    setSearchText(textFilter == undefined ? '' : textFilter)
  }

  const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
    setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
    setSearchText(serchValue == undefined ? "" : serchValue)
    setRowsPerPage(pageSize)
  }

  useEffect(() => {
    getApi('HandWorkCosting/designer/lookup').then(({ data, status }) => {
      if (status === 200) {
        setDesigners(data)
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
    })

    getApi('User/user-lookup').then(({ data, status }) => {
      if (status === 200) {
        setUsers(data)
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
    })

  }, [])

  // user list api
  const HandWorkOrderListApi = () => {
    setIsLoading(true)
    setScreenLoad(true)
    if (loginId == 1 || TaskTitleTypes?.includes("16") || TaskTitleTypes?.includes("14")) {
      postApi("HandWorkOrder/list", {
        fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
          dateFilter[0],
          "yyyy-MM-dd"
        ) : new Date().toISOString().slice(0, 10),
        toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
          dateFilter[1],
          "yyyy-MM-dd"
        ) : new Date().toISOString().slice(0, 10),
        designBy: parseInt(designerFilter),
        Status: statusFilter?.join(',') || '',
        UserId: parseInt(userFilter),
        displayStart: displayStart,
        pageSize: rowsPerPage,
        searchText: searchText.trim(),
        sortColumn: "",
        sortOrder: "asc",
      }).then(async ({ data, status }) => {
        if (status === 200) {

          const { data: categoryData, status: catStatus } = await getApi("Common/category/lookup");

          if (catStatus === 200) {
            const mappedOrders = data?.HandWorkOrderList?.map(order => ({
              ...order,
              CategoryNames: order.CategoryIds.split(",")
                .map(id => {
                  const match = categoryData.find(cat => cat.Key === Number(id));
                  return match ? match.Value : id;
                })
                .filter(Boolean)
                .join(", ")
            }));
            setTableData(mappedOrders);
            setTotalRecords(data?.TotalRecords);
          }
        } else {
          toast.error(data, {
            style: {
              fontSize: "15px",
            },
          })
        }
        setIsLoading(false)
        setScreenLoad(false)
      })
    }
    else {
      postApi("HandWorkCosting/list", {
        fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
          dateFilter[0],
          "yyyy-MM-dd"
        ) : new Date().toISOString().slice(0, 10),
        toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
          dateFilter[1],
          "yyyy-MM-dd"
        ) : new Date().toISOString().slice(0, 10),
        designBy: parseInt(userFilter),
        Status: statusFilter?.join(',') || '',
        displayStart: displayStart,
        pageSize: rowsPerPage,
        searchText: searchText.trim(),
        sortColumn: "",
        sortOrder: "asc",
      }).then(({ data, status }) => {
        if (status === 200) {
          setTableData(data?.HandWorkList)
          setTotalRecords(data?.TotalRecords)
        } else {
          toast.error(data, {
            style: {
              fontSize: "15px",
            },
          })
        }
        setIsLoading(false)
        setScreenLoad(false)
      })
    }
  }

  // user list api useEffect
  useEffect(() => {
    if (dateFilter[1] != undefined) {
      HandWorkOrderListApi()
    }
  }, [searchText, displayStart, rowsPerPage, userFilter, dateFilter, dateDisble, designerFilter, statusFilter])

  // Delete user handler
  const handleDelete = Id => {
    setScreenLoad(true)
    if (Id) {
      DeleteModel.confirmDeleteInquiry({
        title: "Are you sure? ",
        text: "You want to delete this record permanently? ",
        isMobile,
      }).then(response => {
        if (response == true) {
          deleteApi(`HandWorkOrder/delete?id=${Id}`).then(
            async ({ data, status }) => {
              if (status === 200) {
                const updatedArray = tableData
                  .map(obj => (obj.Id !== Id ? obj : null))
                  .filter(Boolean)
                setTableData(updatedArray)
                toast.success("Sucessfully deleted", {
                  style: {
                    fontSize: "15px",
                  },
                })
              } else {
                ErrorModel.errormodel({
                  title: "Verify Handwork",
                  text: data,
                })
              }
              setScreenLoad(false)
            }
          )
        } else {
          setScreenLoad(false)
        }
      })
    }
  }

  // Update user handler
  const handleEditOrder = (orderData) => {
    if (orderData) {
      setEditData(orderData)
      setIsEdit(true)
      setModal(!modal)
    }
  }

  //  handwork images handler
  const handleUploadImages = (orderData) => {
    if (orderData) {
      const imageArray = orderData.Images
        ? orderData.Images.split('|').filter(Boolean)
        : [];

      setImages(imageArray);
      setHandWorkOrderId(orderData.Id);
      setImagesUrls(imageArray);
      uploadImagesOrderToggle(); // open modal or UI toggle
    }
  };

  const handleViewImages = (orderData) => {
    if (orderData) {
      const imageArray = orderData.Images
        ? orderData.Images.split('|').filter(Boolean)
        : [];

      setImages(imageArray);
      setImagesUrls(imageArray);
      setHandWorkOrderId(orderData.Id);
      viewImagesOrderToggle(); // open modal or UI toggle
    }
  };

  const uploadImagesOrderToggle = () => {
    setUploadImagesModal(!uploadImagesModal)
  }

  const viewImagesOrderToggle = () => {
    setViewImagesModal(!viewImagesModal)
  }

  const UploadImageshandleCancle = () => {
    uploadImagesOrderToggle()
  }

  const handleUploadImagesSubmit = () => {
    setformSumitLoading(true)
    postApi("HandWorkOrder/upload-images", {
      HandWorkOrderId: handWorkOrderId,
      imageUrls: imagesUrls.join('|'),
      imageBase64: imagesBase64,
      imageDelete: deleteImages.join('|'),
    }).then(({ data, status }) => {
      setformSumitLoading(false)
      if (status == 200) {
        HandWorkOrderListApi()
        toast.success("successfully uploaded", {
          style: {
            fontSize: "15px",
          },
        })
        uploadImagesOrderToggle()
        setImagesBase64([])
        setImages([])
        setDeleteImages([])
        setImagesUrls([])
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
    })
  }

  const stitchingOrderToggle = () => {
    setStitchingModal(!stitchingModal)

  }

  // Create user handler
  const handleCustomerAttendClick = () => {
    setIsEdit(false)
    toggle()
  }

  // popup box handler
  const toggle = () => {
    setModal(!modal)
  }

  // popup box handler
  const handWoekOrderDetailtoggle = () => {
    setHandWorkDetailModal(!handWorkDetailModal)
  }

  // popup box handler
  const handWoekAllOrderDetailtoggle = () => {
    setHandworkOrderAllDetailModal(!handworkOrderAllDetailModal)
  }

  const HandleDesignerChange = (designerId, handworkOrderId) => {
    DeleteModel.confirmDeleteInquiry({
      title: "Are you sure? ",
      text: "You want to update this designer? ",
      isMobile,
    }).then(response => {
      if (response == true) {
        putApi(`HandWorkCosting/update-designer`,
          {
            HandWorkOrderId: handworkOrderId,
            DesignerId: parseInt(designerId),
          }
        ).then(
          async ({ data, status }) => {
            if (status === 200) {
              toast.success("Sucessfully updated", {
                style: {
                  fontSize: "15px",
                },
              })
              HandWorkOrderListApi()
            } else {
              toast.error(data, {
                style: {
                  fontSize: "15px",
                },
              })
            }
            setScreenLoad(false)
          }
        )
      } else {
        setScreenLoad(false)
      }
    })
  }

  const converHandWorkOrderToggle = () => {
    setHandwWorkOrderModal(!handwWorkOrderModal)
  }

  const handleConverHandwork = (handWorkOrderId, designerId, categoriesIds, data) => {
    setHandWorkOrderId(handWorkOrderId)
    setEditData(data)
    setCategoriesIds(categoriesIds)
    setDesignerId(designerId)
    converHandWorkOrderToggle()
  }

  const handleViewHandWorOrderkDetail = (handworkOrderId) => {
    setHandWorkOrderId(handworkOrderId)
    handWoekOrderDetailtoggle()
  }

  const handleViewAllHandWorOrderkDetail = (handworkOrderId) => {
    setHandWorkOrderId(handworkOrderId)
    handWoekAllOrderDetailtoggle()
  }

  const updateEndDateTimeToggle = () => {
    setUpdateEndDateTimeModal(!updateEndDateTimeModal)
  }

  const handleStatusChange = (data, status) => {
    setHandWorkId(data?.Id)
    setEditData(data)
    if (status == 5 && isStatus) {
      setIsStatus(false)
      DeleteModel.confirmDeleteInquiry({
        title: "Are you sure? ",
        text: "You want to change this status? ",
        isMobile,
      }).then(response => {
        if (response == true) {
          postApi("HandWorkCosting/status-change", {
            Id: data.Id,
            Status: parseInt(status),
            InputEndDateTime: null
          }).then(({ data, status }) => {
            if (status == 200) {
              HandWorkOrderListApi()
              toast.success("successfully updated", {
                style: {
                  fontSize: "15px",
                },
              })
            } else {
              toast.error(data, {
                style: {
                  fontSize: "15px",
                },
              })
            }
          })
        } else {
          setIsLoading(false)
        }
      })
    }
    else if (status == 5) {
      stitchingOrderToggle()
      setStitchingMasterId({
        label: data?.StitchingMasterByName || 'Select Master',
        value: data?.StitchingMasterId || 0,
      })
      setStitchingWorkerId({
        label: data?.StitchingWorkerByName || 'Select Worker',
        value: data?.StitchingWorkerId || 0,
      })
      validation.setFieldValue("Costing", data?.Costing || '')
      validation.setFieldValue("StuffDetails", data?.StuffDetails || '')
      setIsStatus(true)
    }
    else {
      DeleteModel.confirmDeleteInquiry({
        title: "Are you sure? ",
        text: "You want to change this status? ",
        isMobile,
      }).then(response => {
        if (response == true) {
          if (status == 4) {
            updateEndDateTimeToggle()
          } else {
            postApi("HandWorkCosting/status-change", {
              Id: data.Id,
              Status: parseInt(status),
              InputEndDateTime: null
            }).then(({ data, status }) => {
              if (status == 200) {
                HandWorkOrderListApi()
                toast.success("successfully updated", {
                  style: {
                    fontSize: "15px",
                  },
                })
              } else {
                toast.error(data, {
                  style: {
                    fontSize: "15px",
                  },
                })
              }
            })
          }
        } else {
          setIsLoading(false)
        }
      })
    }

  }

  // table headers & accessor
  const adminColumns = useMemo(
    () => [
      {
        Header: "Order No.",
        accessor: "OrderNo",
        width: "8%",
        Cell: ({ row }) => {
          return (
            <div style={{ textAlign: "center" }}>
              {(TaskTitleTypes == null) ?
                <div style={{ color: "blue", cursor: "pointer" }} onClick={() => handleViewHandWorOrderkDetail(row.original.Id)}>
                  {row.original.OrderNo}
                </div>
                :
                <>{row.original.OrderNo}</>
              }
            </div>
          )
        },
      },
      {
        Header: "Unique No.",
        accessor: "UniqueNo",
        width: "8%",
        Cell: ({ row }) => {
          return (
            <div style={{ textAlign: "center" }}>
              {(TaskTitleTypes == null) ?
                <div style={{ color: "blue", cursor: "pointer" }} onClick={() => handleViewAllHandWorOrderkDetail(row.original.Id)}>
                  {row.original.UniqueNo}
                </div>
                :
                <>{row.original.UniqueNo}</>
              }
            </div>
          )
        },
      },
      {
        Header: "Name",
        accessor: "Name",
      },
      {
        Header: "Details",
        accessor: "Details",
        disableSorting: true,
        Cell: ({ row }) => (
          <>
            <style>
              {`
          .text-ellipsis {
            max-width: 150px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
          }
        `}
            </style>
            <p
              className="mb-0 text-ellipsis"
              data-toggle="tooltip"
              data-placement="bottom"
              title={row.original?.Details || ""}
            >
              {row.original?.Details || "N/A"}
            </p>
          </>
        ),
      },
      {
        Header: "Categories",
        accessor: "CategoryNames",
        disableSorting: true,
        Cell: ({ row }) => (
          <>
            <style>
              {`
          .text-ellipsis {
            max-width: 150px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
          }
        `}
            </style>
            <p
              className="mb-0 text-ellipsis"
              data-toggle="tooltip"
              data-placement="bottom"
              title={row.original?.CategoryNames || ""}
            >
              {row.original?.CategoryNames || "N/A"}
            </p>
          </>
        ),
      },
      {
        Header: "Required Date",
        accessor: "RequiredDate",
        width: "8%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original?.RequiredDate == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(row.original?.RequiredDate?.split("T")[0], "dd-MM-yyyy")}
          </p>
        ),
      },
      {
        Header: "Designer",
        accessor: "DesignerByName",
        width: "3%",
        Cell: ({ row }) => (
          <>
            {
              TaskTitleTypes == null
                ?
                <div>
                  <Input
                    type="select"
                    id="validationCustom01"
                    className="form-control-sm"
                    onChange={e => { HandleDesignerChange(e.target.value, row.original.Id) }}
                    value={row.original.DesignerId}
                    bsSize="sm"
                    name="taskType"
                    style={{ width: "150px" }}
                  >
                    {row.original.DesignerId == 0 &&
                      <option value={0}>
                        Select
                      </option>
                    }
                    {designers.map((item, index) => {
                      return (
                        <option key={index} value={item.Key}>
                          {item.Value}
                        </option>
                      )
                    })}
                  </Input>
                </div>
                :
                <div>{row.original.DesignerByName ? row.original.DesignerByName : "N/A"}</div>
            }
          </>
        )
      },
      {
        Header: "Status",
        accessor: "Status",
        width: "10%",
        Cell: ({ row }) => {
          return (
            <div style={{ textAlign: "center" }}>
              <>{GetObjByHandWorkOrderStatus(row.original.Status)[0]?.Key}</>
            </div>
          )
        },
      },
      {
        Header: "Created By",
        accessor: "CreatedByName",
        width: "8%"
      },
      {
        Header: "Created On",
        accessor: "CreatedOn",
        width: "8%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original?.CreatedOn == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(row.original?.CreatedOn.split("T")[0], "dd-MM-yyyy")}
          </p>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Action
          </div>
        ),
        width: "10%",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">

              {((TaskTitleTypes == null) || (TaskTitleTypes.includes("16"))) &&
                <li className="mytooltip">
                  <i
                    className=" fs-6 fas fa-edit btn-edit"
                    id={`edittooltip${row.original.Id}`}
                    onClick={() => handleEditOrder(row.original)}
                  ></i>
                  <span className="mytext">Edit</span>
                </li>
              }

              {(TaskTitleTypes == null) &&
                <>
                  {/* {row.original.Status != 1
                    ?
                    <li className="mytooltip">
                      <i
                        className={`fs-6 fas fa-trash-alt btn-delete`}
                        style={{ cursor: "not-allowed", color: "#808080b3" }}
                      ></i>
                      <span className="mytext">Delete</span>
                    </li>
                    : */}
                    <li className="mytooltip">
                      <i
                        className="fs-6 fas fa-trash-alt btn-delete"
                        id={`deletetooltip${row.original.Id}`}
                        onClick={() => handleDelete(row.original.Id)}
                      ></i>
                      <span className="mytext">Delete</span>
                    </li>
                  {/* } */}
                  <li className="mytooltip">
                    <i
                      className=" fs-6 fas fa-photo-video"
                      id={`edittooltip${row.original.Id}`}
                      onClick={() => handleViewImages(row.original)}
                    ></i>
                    <span className="mytext">View Images</span>
                  </li>
                </>
              }
            </ul>
          )
        },
      },
    ],
    [tableData, designers]
  )

  const designerColumns = useMemo(
    () => [
      {
        Header: "Order No.",
        accessor: "OrderNo",
        width: "8%",
      },
      {
        Header: "Unique No",
        accessor: "UniqueNo",
        width: "8%",
      },
      {
        Header: "Name",
        accessor: "Name",
      },
      {
        Header: "Details",
        accessor: "Details",
        disableSorting: true,
        Cell: ({ row }) => (
          <>
            <style>
              {`
          .text-ellipsis {
            max-width: 150px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
          }
        `}
            </style>
            <p
              className="mb-0 text-ellipsis"
              data-toggle="tooltip"
              data-placement="bottom"
              title={row.original?.Details || ""}
            >
              {row.original?.Details || "N/A"}
            </p>
          </>
        ),
      },
      {
        Header: "Categories",
        accessor: "CategoryNames",
        disableSorting: true,
        Cell: ({ row }) => (
          <>
            <style>
              {`
          .text-ellipsis {
            max-width: 150px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
          }
        `}
            </style>
            <p
              className="mb-0 text-ellipsis"
              data-toggle="tooltip"
              data-placement="bottom"
              title={row.original?.CategoryNames || ""}
            >
              {row.original?.CategoryNames || "N/A"}
            </p>
          </>
        ),
      },
      {
        Header: "Required Date",
        accessor: "RequiredDate",
        width: "8%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original?.RequiredDate == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(row.original?.RequiredDate?.split("T")[0], "dd-MM-yyyy")}
          </p>
        ),
      },
      {
        Header: "Designer",
        accessor: "DesignerByName",
        width: "3%",
        Cell: ({ row }) => (
          <>
            {
              TaskTitleTypes == null
                ?
                <div>
                  <Input
                    type="select"
                    id="validationCustom01"
                    className="form-control-sm"
                    onChange={e => { HandleDesignerChange(e.target.value, row.original.Id) }}
                    value={row.original.DesignerId}
                    bsSize="sm"
                    name="taskType"
                    style={{ width: "150px" }}
                  >
                    <option value={0}>
                      Select
                    </option>
                    {designers.map((item, index) => {
                      return (
                        <option key={index} value={item.Key}>
                          {item.Value}
                        </option>
                      )
                    })}
                  </Input>
                </div>
                :
                <div>{row.original.DesignerByName ? row.original.DesignerByName : "N/A"}</div>
            }
          </>
        )
      },
      {
        Header: "Status",
        accessor: "Status",
        width: "4%",
        Cell: ({ row }) => {
          return (
            <div style={{ textAlign: "center" }}>
              <>{GetObjByHandWorkOrderStatus(row.original.Status)[0]?.Key}</>
            </div>
          )
        },
      },
      {
        Header: "Created By",
        accessor: "CreatedByName",
        width: "8%"
      },
      {
        Header: "Created On",
        accessor: "CreatedOn",
        width: "8%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original?.CreatedOn == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(row.original?.CreatedOn.split("T")[0], "dd-MM-yyyy")}
          </p>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Action
          </div>
        ),
        width: "10%",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
              <>
                {row.original.Status == 2 ?
                  <li className="mytooltip">
                    <i
                      className="fs-6 fas fa-feather-alt"
                      id={`edittooltip${row.original.Id}`}
                      style={{ color: "#556ee6" }}
                      onClick={() => handleConverHandwork(row.original.Id, row.original.DesignerId, row.original.CategoryIds, row.original)}
                    ></i>
                    <span className="mytext">Convert To handwork</span>
                  </li>
                  :
                  <li className="mytooltip">
                    <i
                      className="fs-6 fas fa-feather-alt"
                      style={{ cursor: "not-allowed", color: "#808080b3" }}
                    ></i>
                    <span className="mytext">Convert To handwork</span>
                  </li>
                }
                <li className="mytooltip">
                  <i
                    className=" fs-6 fas fa-photo-video"
                    id={`edittooltip${row.original.Id}`}
                    onClick={() => handleViewImages(row.original)}
                  ></i>
                  <span className="mytext">View Images</span>
                </li>
              </>
            </ul>
          )
        },
      },
    ],
    [tableData, designers]
  )

  const salesOrderColumns = useMemo(
    () => [
      {
        Header: "Order No.",
        accessor: "OrderNo",
        width: "8%",
        // Cell: ({ row }) => {
        //   return (
        //     <div style={{ textAlign: "center" }}>
        //       {(TaskTitleTypes == null) ?
        //         <div style={{ color: "blue", cursor: "pointer" }} onClick={() => handleViewHandWorkDetail(row.original.Id)}>
        //           {row.original.OrderNo}
        //         </div>
        //         :
        //         <>{row.original.OrderNo}</>
        //       }
        //     </div>
        //   )
        // },
      },
      {
        Header: "Unique No",
        accessor: "UniqueNo",
        width: "8%",
      },
      {
        Header: "Name",
        accessor: "Name",
      },
      {
        Header: "Details",
        accessor: "Details",
        disableSorting: true,
        Cell: ({ row }) => (
          <>
            <style>
              {`
          .text-ellipsis {
            max-width: 150px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
          }
        `}
            </style>
            <p
              className="mb-0 text-ellipsis"
              data-toggle="tooltip"
              data-placement="bottom"
              title={row.original?.Details || ""}
            >
              {row.original?.Details || "N/A"}
            </p>
          </>
        ),
      },
      {
        Header: "Categories",
        accessor: "CategoryNames",
        disableSorting: true,
        Cell: ({ row }) => (
          <>
            <style>
              {`
          .text-ellipsis {
            max-width: 150px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
          }
        `}
            </style>
            <p
              className="mb-0 text-ellipsis"
              data-toggle="tooltip"
              data-placement="bottom"
              title={row.original?.CategoryNames || ""}
            >
              {row.original?.CategoryNames || "N/A"}
            </p>
          </>
        ),
      },
      {
        Header: "Required Date",
        accessor: "RequiredDate",
        width: "8%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original?.RequiredDate == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(row.original?.RequiredDate?.split("T")[0], "dd-MM-yyyy")}
          </p>
        ),
      },
      {
        Header: "Status",
        accessor: "Status",
        width: "4%",
        Cell: ({ row }) => {
          return (
            <div style={{ textAlign: "center" }}>
              <>{GetObjByHandWorkOrderStatus(row?.original?.Status)[0]?.Key}</>
            </div>
          )
        },
      },
      {
        Header: "Created By",
        accessor: "CreatedByName",
        width: "8%"
      },
      {
        Header: "Created On",
        accessor: "CreatedOn",
        width: "8%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original?.CreatedOn == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(row.original?.CreatedOn.split("T")[0], "dd-MM-yyyy")}
          </p>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Action
          </div>
        ),
        width: "10%",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
              <>
                {row.original.Status == 1 ?
                  <>
                    <li className="mytooltip">
                      <i
                        className=" fs-6 fas fa-edit btn-edit"
                        id={`edittooltip${row.original.Id}`}
                        onClick={() => handleEditOrder(row.original)}
                      ></i>
                      <span className="mytext">Edit</span>
                    </li>
                  </>
                  :
                  <li className="mytooltip">
                    <i
                      className={`fs-6 fas fa-edit`}
                      style={{ cursor: "not-allowed", color: "#808080b3" }}
                    ></i>
                    <span className="mytext">Edit</span>
                  </li>
                }
                <li className="mytooltip">
                  <i
                    className=" fs-6 fas  fa-cloud-upload-alt"
                    id={`edittooltip${row.original.Id}`}
                    onClick={() => handleUploadImages(row.original)}
                  ></i>
                  <span className="mytext">upload Images</span>
                </li>
              </>
            </ul>
          )
        },
      },
    ],
    [tableData, designers]
  )

  const stitchingColumns = useMemo(
    () => [
      {
        Header: "Order No.",
        accessor: "OrderNo",
        width: "8%",
      },
      {
        Header: "Unique No",
        accessor: "UniqueNo",
        width: "8%",
      },
      {
        Header: "Name",
        accessor: "Name",
      },
      {
        Header: "Details",
        accessor: "Details",
        disableSorting: true,
        Cell: ({ row }) => (
          <p
            className="mb-0"
            data-toggle="tooltip"
            data-placement="bottom"
            title={`${row.original?.Details == null ? '' : row.original?.Details}`}
          >
            {/* {row.original?.Details} */}
            {row.original?.Details?.length > 15
              ? `${row.original?.Details?.substr(0, 15)}...`
              : row.original?.Details == ""
                ? "N/A"
                : row.original?.Details}
          </p>
        ),
      },
      {
        Header: "Designer",
        accessor: "DesignerByName",
        width: "3%",
      },
      {
        Header: "Required Date",
        accessor: "RequiredDate",
        width: "8%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original?.RequiredDate == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(row.original?.RequiredDate?.split("T")[0], "dd-MM-yyyy")}
          </p>
        ),
      },
      {
        Header: "Category",
        accessor: "CategoryName",
        width: "8%",
      },
      {
        Header: "Stitching Master",
        accessor: "StitchingMasterByName",
        width: "8%",
        Cell: ({ row }) => {
          return (
            <div style={{ textAlign: "center" }}>
              <>{row.original.StitchingMasterByName ? row.original.StitchingMasterByName : "N/A"}</>
            </div>
          )
        },
      },
      {
        Header: "Stitching Worker",
        accessor: "StitchingWorkerByName",
        width: "8%",
        Cell: ({ row }) => {
          return (
            <div style={{ textAlign: "center" }}>
              <>{row.original.StitchingWorkerByName ? row.original.StitchingWorkerByName : "N/A"}</>
            </div>
          )
        },
      },
      {
        Header: "Costing",
        Header: () => (
          <div
            style={{
              textAlign: "right",
            }}
          >
            Costing
          </div>
        ),
        accessor: "Costing",
        width: "8%",
        Cell: ({ row }) => {
          return (
            <div style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "end",
              textAlign: "end"
            }}>
              <i className="mdi mdi-currency-inr"></i>
              {new Intl.NumberFormat('en-IN', {
                currency: 'INR',
                minimumFractionDigits: 2,
              }).format(row?.original?.Costing || 0)}
            </div>
          )
        },
      },
      {
        Header: "Stuff Details",
        accessor: "StuffDetails",
        disableSorting: true,
        Cell: ({ row }) => (
          <p
            className="mb-0"
            data-toggle="tooltip"
            data-placement="bottom"
            title={`${row.original?.StuffDetails == null ? '' : row.original?.StuffDetails}`}
          >
            {/* {row.original?.StuffDetails} */}
            {row.original?.StuffDetails?.length > 15
              ? `${row.original?.StuffDetails?.substr(0, 15)}...`
              : row.original?.StuffDetails == ""
                ? "N/A"
                : row.original?.StuffDetails}
          </p>
        ),
      },
      {
        Header: "Status",
        accessor: "Status",
        width: "10%",
        Cell: ({ row }) => (
          <div>
            <Input
              disabled={row.original.Status == 5}
              type="select"
              bsSize="sm"
              id="validationCustom01"
              className="form-control-sm"
              style={{ width: "110px" }}
              onChange={e => {
                handleStatusChange(row.original, e.target.value)
              }}
              value={row.original.Status}
            >
              {row.original.Status == 1 ?
                <>
                  {GetObjByHandWorkCostingStatus(1, 2, 3, 4, 5).map((item, index) => {
                    return (
                      <option key={index} value={item.Value}>
                        {item.Key}
                      </option>
                    )
                  })}
                </>
                :
                row.original.Status == 2 ?
                  <>
                    {GetObjByHandWorkCostingStatus(2, 3, 4, 5).map((item, index) => {
                      return (
                        <option key={index} value={item.Value}>
                          {item.Key}
                        </option>
                      )
                    })}
                  </>
                  :
                  row.original.Status == 3 ?
                    <>
                      {GetObjByHandWorkCostingStatus(2, 3).map((item, index) => {
                        return (
                          <option key={index} value={item.Value}>
                            {item.Key}
                          </option>
                        )
                      })}
                    </>
                    :
                    row.original.Status == 4 ?
                      <>
                        {GetObjByHandWorkCostingStatus(4, 5).map((item, index) => {
                          return (
                            <option key={index} value={item.Value}>
                              {item.Key}
                            </option>
                          )
                        })}
                      </>
                      :
                      <>
                        {GetObjByHandWorkCostingStatus(5).map((item, index) => {
                          return (
                            <option key={index} value={item.Value}>
                              {item.Key}
                            </option>
                          )
                        })}
                      </>
              }

            </Input>
          </div>
        )
      },
      {
        Header: "Created By",
        accessor: "CreatedByName",
        width: "8%"
      },
      {
        Header: "Created On",
        accessor: "CreatedOn",
        width: "8%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original?.CreatedOn == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(row.original?.CreatedOn.split("T")[0], "dd-MM-yyyy")}
          </p>
        ),
      },
    ],
    [tableData, designers]
  )

  function writeDataToExcel() {
    if ((!statusFilter.includes(2) && !dateDisble)) {
      toast.error("Please Select date", {
        icon: "⚠️",
        style: {
          fontSize: "15px",
        },
      })
    } else {
      setIsLoading(true)
      let header = ["Unique No", "Order No.", "Name", "Designer", "Required Date", "Details", "Created By", "Created On"];
      let header2 = ["Unique No", "Order No.", "Name", "Designer", "Required Date", "Details", "Created By", "Created On"];
      let header3 = ["Unique No", "Order No.", "Name", "Designer", "Required Date", "Category", "Stitching Master", "Stitching Worker", "Costing", "Status", "Stuff Details", "Details", "Created By", "Created On"];
      const mainTitle = (TaskTitleTypes?.includes("14")) ? "Designer Order" : (TaskTitleTypes?.includes("17")) ? "Order Stitching" : "Hand Work Order";
      const widthObj = [{
        Key: "A",
        Value: 10,
      },
      {
        Key: "B",
        Value: 19,
      },
      {
        Key: "C",
        Value: 19,
      },
      {
        Key: "D",
        Value: 19,
      },
      {
        Key: "E",
        Value: 19,
      },
      {
        Key: "F",
        Value: 19,
      },
      {
        Key: "G",
        Value: 19,
      },
      {
        Key: "H",
        Value: 19,
      },
      {
        Key: "I",
        Value: 19,
      },
      {
        Key: "J",
        Value: 19,
      },
      ]
      const extention = (TaskTitleTypes?.includes("14")) ? "Designer_Order" : (TaskTitleTypes?.includes("17")) ? "Hand_Work_Order_Stitching" : "Hand_Work_Order.xlsx"
      let excelSheetData = []
      if (loginId == 1 || TaskTitleTypes?.includes("16") || TaskTitleTypes?.includes("14")) {
        postApi("HandWorkOrder/list", {
          fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
            dateFilter[0],
            "yyyy-MM-dd"
          ) : new Date().toISOString().slice(0, 10),
          toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
            dateFilter[1],
            "yyyy-MM-dd"
          ) : new Date().toISOString().slice(0, 10),
          designBy: parseInt(designerFilter),
          Status: statusFilter?.join(',') || '',
          UserId: parseInt(userFilter),
          displayStart: displayStart,
          pageSize: 10000,
          searchText: searchText.trim(),
          sortColumn: "",
          sortOrder: "asc",
        }).then(({ data, status }) => {
          if (status === 200) {
            for (let index = 0; index < data?.HandWorkOrderList.length; index++) {
              let dataObjAdmin = {
                UniqueNo: data?.HandWorkOrderList[index].UniqueNo,
                OrderNo: data?.HandWorkOrderList[index].OrderNo,
                Name: data?.HandWorkOrderList[index].Name,
                Designer: data?.HandWorkOrderList[index].DesignerByName ? data?.HandWorkOrderList[index].DesignerByName : "N/A",
                RequiredDate: data?.HandWorkOrderList[index].RequiredDate == null
                  ? "N/A"
                  : dateFormat(data?.HandWorkOrderList[index].RequiredDate, "dd-MM-yyyy"),
                Details: data?.HandWorkOrderList[index].Details ? data?.HandWorkOrderList[index].Details : "N/A",
                CreatedByName: data?.HandWorkOrderList[index].CreatedByName,
                CreatedOn: data?.HandWorkOrderList[index].CreatedOn == null
                  ? "N/A"
                  : dateFormat(data?.HandWorkOrderList[index].CreatedOn, "dd-MM-yyyy"),
              }

              let dataObjSalesAndDesigner = {
                UniqueNo: data?.HandWorkOrderList[index].UniqueNo,
                OrderNo: data?.HandWorkOrderList[index].OrderNo,
                Name: data?.HandWorkOrderList[index].Name,
                Designer: data?.HandWorkOrderList[index].DesignerByName ? data?.HandWorkOrderList[index].DesignerByName : "N/A",
                RequiredDate: data?.HandWorkOrderList[index].RequiredDate == null
                  ? "N/A"
                  : dateFormat(data?.HandWorkOrderList[index].RequiredDate, "dd-MM-yyyy"),
                Details: data?.HandWorkOrderList[index].Details ? data?.HandWorkOrderList[index].Details : "N/A",
                CreatedByName: data?.HandWorkOrderList[index].CreatedByName,
                CreatedOn: data?.HandWorkOrderList[index].CreatedOn == null
                  ? "N/A"
                  : dateFormat(data?.HandWorkOrderList[index].CreatedOn, "dd-MM-yyyy"),
              }
              excelSheetData.push((TaskTitleTypes?.includes("14")) ? dataObjSalesAndDesigner : dataObjAdmin)
            }
            var fields = Object.keys(excelSheetData[0]);
            var sheetData = excelSheetData.map(function (row) {
              return fields.map(function (fieldName) {
                return row[fieldName];
              });
            });
            setIsLoading(false)
            sheetData.unshift((TaskTitleTypes?.includes("14")) ? header2 : header);
            exportDataExcel(sheetData, mainTitle, widthObj, extention)
          } else {
            toast.error(data, {
              style: {
                fontSize: "15px",
              },
            })
          }
          setIsLoading(false)
          setScreenLoad(false)
        })
      } else {
        postApi("HandWorkCosting/list", {
          fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
            dateFilter[0],
            "yyyy-MM-dd"
          ) : new Date().toISOString().slice(0, 10),
          toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
            dateFilter[1],
            "yyyy-MM-dd"
          ) : new Date().toISOString().slice(0, 10),
          designBy: parseInt(userFilter),
          Status: statusFilter?.join(',') || '',
          displayStart: displayStart,
          pageSize: 10000,
          searchText: searchText.trim(),
          sortColumn: "",
          sortOrder: "asc",
        }).then(({ data, status }) => {
          if (status === 200) {
            for (let index = 0; index < data?.HandWorkList.length; index++) {
              let dataObjAdmin = {
                UniqueNo: data?.HandWorkList[index].UniqueNo,
                OrderNo: data?.HandWorkList[index].OrderNo,
                Name: data?.HandWorkList[index].Name,
                Designer: data?.HandWorkList[index].DesignerByName ? data?.HandWorkList[index].DesignerByName : "N/A",
                RequiredDate: data?.HandWorkList[index].RequiredDate == null
                  ? "N/A"
                  : dateFormat(data?.HandWorkList[index].RequiredDate, "dd-MM-yyyy"),
                Details: data?.HandWorkList[index].Details ? data?.HandWorkList[index].Details : "N/A",
                CreatedByName: data?.HandWorkList[index].CreatedByName,
                CreatedOn: data?.HandWorkList[index].CreatedOn == null
                  ? "N/A"
                  : dateFormat(data?.HandWorkList[index].CreatedOn, "dd-MM-yyyy"),
              }

              let dataObjSalesAndDesigner = {
                UniqueNo: data?.HandWorkList[index].UniqueNo,
                OrderNo: data?.HandWorkList[index].OrderNo,
                Name: data?.HandWorkList[index].Name,
                Designer: data?.HandWorkList[index].DesignerByName ? data?.HandWorkList[index].DesignerByName : "N/A",
                RequiredDate: data?.HandWorkList[index].RequiredDate == null
                  ? "N/A"
                  : dateFormat(data?.HandWorkList[index].RequiredDate, "dd-MM-yyyy"),
                Category: data?.HandWorkList[index].CategoryName,
                Details: data?.HandWorkList[index].Details ? data?.HandWorkList[index].Details : "N/A",
                CreatedByName: data?.HandWorkList[index].CreatedByName,
                CreatedOn: data?.HandWorkList[index].CreatedOn == null
                  ? "N/A"
                  : dateFormat(data?.HandWorkList[index].CreatedOn, "dd-MM-yyyy"),
              }

              let dataObjStitching = {
                UniqueNo: data?.HandWorkList[index].UniqueNo,
                OrderNo: data?.HandWorkList[index].OrderNo,
                Name: data?.HandWorkList[index].Name,
                Designer: data?.HandWorkList[index].DesignerByName ? data?.HandWorkList[index].DesignerByName : "N/A",
                RequiredDate: data?.HandWorkList[index].RequiredDate == null
                  ? "N/A"
                  : dateFormat(data?.HandWorkList[index].RequiredDate, "dd-MM-yyyy"),
                StitchingMasterByName: data?.HandWorkList[index].StitchingMasterByName ? data?.HandWorkList[index].StitchingMasterByName : "N/A",
                StitchingWorkerByName: data?.HandWorkList[index].StitchingWorkerByName ? data?.HandWorkList[index].StitchingWorkerByName : "N/A",
                Costing: Math.round(data?.HandWorkList[index].Costing).toFixed(2),
                Status: GetObjByHandWorkCostingStatus(data?.HandWorkList[index].Status)[0]?.Key,
                Details: data?.HandWorkList[index].Details ? data?.HandWorkList[index].Details : "N/A",
                StuffDetails: data?.HandWorkList[index].StuffDetails ? data?.HandWorkList[index].StuffDetails : "N/A",
                CreatedByName: data?.HandWorkList[index].CreatedByName,
                CreatedOn: data?.HandWorkList[index].CreatedOn == null
                  ? "N/A"
                  : dateFormat(data?.HandWorkList[index].CreatedOn, "dd-MM-yyyy"),
              }
              excelSheetData.push((TaskTitleTypes?.includes("14")) ? dataObjSalesAndDesigner : (TaskTitleTypes?.includes("17")) ? dataObjStitching : dataObjAdmin)
            }
            var fields = Object.keys(excelSheetData[0]);
            var sheetData = excelSheetData.map(function (row) {
              return fields.map(function (fieldName) {
                return row[fieldName];
              });
            });
            setIsLoading(false)
            sheetData.unshift((TaskTitleTypes?.includes("14")) ? header2 : (TaskTitleTypes?.includes("17")) ? header3 : header);
            exportDataExcel(sheetData, mainTitle, widthObj, extention)
          } else {
            toast.error(data, {
              style: {
                fontSize: "15px",
              },
            })
          }
          setIsLoading(false)
          setScreenLoad(false)
        })
      }
      setIsLoading(false)
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      Costing: isEdit ? editData?.Costing : '',
      StuffDetails: isEdit ? editData?.StuffDetails : '',
    },
    validationSchema: Yup.object({
      Costing: Yup.string().required("The Costing is required"),
    }),
    onSubmit: values => {

      if (stitchingMasterId.value == 0) {
        setIsStitchingMasterSelected(true)
        return true
      }
      if (stitchingWorkerId.value == 0) {
        setIsStitchingWorkerSelected(true)
        return true
      }

      setformSumitLoading(true)
      if (values) {
        setIsStitchingMasterSelected(false)
        setIsStitchingWorkerSelected(false)
        putApi("HandWorkOrder/add-stitching-details", {
          id: parseInt(editData?.Id),
          StitchingMasterId: parseInt(stitchingMasterId?.value),
          StitchingWorkerId: parseInt(stitchingWorkerId?.value),
          Costing: parseFloat(values.Costing),
          StuffDetails: values.StuffDetails,
        }).then(({ data, status }) => {
          setformSumitLoading(false)
          if (status == 200) {
            toast.success(`Sucessfully Added`, {
              style: {
                fontSize: "15px",
              },
            })
            setformSumitLoading(false)
            if (isStatus) {
              handleStatusChange(editData, 5)
            }
            stitchingOrderToggle()
            HandWorkOrderListApi()
            setStitchingMasterId(0)
            setStitchingWorkerId(0)
            validation.handleReset()
          }
          else {
            toast.error(data, {
              style: {
                fontSize: "15px",
              },
            })
          }
        })
      }
    },
  })

  const handleKeyPress = event => {
    const charCode = event.which || event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  };

  // cancle handler
  const handleCancle = () => {
    toggle()
  }

  const handleDrop = async (acceptedFiles) => {
    if (!acceptedFiles?.length) return;

    // Check total limit (existing + new)
    if (images.length + acceptedFiles.length > 8) {
      toast.error("Maximum 8 images are allowed.", {
        style: { fontSize: "15px" },
      });
      return;
    }

    const validImages = acceptedFiles.filter((file) =>
      file.type.startsWith("image/")
    );
    if (validImages.length !== acceptedFiles.length) {
      toast.error("Only image files are allowed.", {
        style: { fontSize: "15px" },
      });
      return;
    }

    const compressedBase64List = [];

    for (const file of validImages) {
      await new Promise((resolve) => {
        new Compressor(file, {
          quality: 0.4,
          success: (compressed) => {
            const reader = new FileReader();
            reader.onload = (e) => {
              compressedBase64List.push(e.target.result);
              imagesBase64.push((e.target.result).split(",")[1]);
              resolve();
            };
            reader.readAsDataURL(compressed);
          },
        });
      });
    }

    // Add new images to existing
    setImages((prev) => [...prev, ...compressedBase64List]);
  };


  const handleRemoveImage = (item) => {
    setImages((prev) => {
      if (item && item.startsWith("http")) {
        setDeleteImages((prevRemoved) => [...prevRemoved, item]);
      }
      return prev.filter((img) => img !== item);
    });
    setImagesUrls((prev) => {
      return prev.filter((img) => img !== item);
    });
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {screenLoad && (
          <div className="loading-overlay is-active">
            <span className="fas fa-spinner fa-3x fa-spin"></span>
          </div>
        )}
        <Breadcrumbs
          title={breadcrumbs[pathname].parent}
          breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
          link={breadcrumbs[pathname].parentLink}
        />
        <Card>
          <CardBody>
            <HandWorkOrderTable
              columns={TaskTitleTypes?.includes("14") ? designerColumns : TaskTitleTypes?.includes("16") ? salesOrderColumns : TaskTitleTypes?.includes("17") ? stitchingColumns : adminColumns}
              data={tableData}
              isGlobalFilter={true}
              isAddUserList={true}
              handleCustomerAttendClick={handleCustomerAttendClick}
              customPageSize={10}
              className="custom-header-css"
              filterData={filterData}
              isLoading={isLoading}
              TotalRecords={totalRecords}
              pagePerSize={pagePerSize}
              setDateFilter={setDateFilter}
              dateFilter={dateFilter}
              users={users}
              userFilter={userFilter}
              designers={designers}
              setUserFilter={setUserFilter}
              designerFilter={designerFilter}
              setDesignerFilter={setDesignerFilter}
              setdateDisble={setdateDisble}
              dateDisble={dateDisble}
              writeDataToExcel={writeDataToExcel}
              statusFilter={statusFilter}
              setStatusFilter={setStatusFilter}
            />

            {modal &&
              <CreateHandWorkOrderModel
                modal={modal}
                toggle={toggle}
                HandWorkOrderListApi={HandWorkOrderListApi}
                isEdit={isEdit}
                editData={editData}
              />
            }

            {handWorkDetailModal &&
              <HandWorkOrderDetailModel
                modal={handWorkDetailModal}
                toggle={handWoekOrderDetailtoggle}
                handWorkOrderId={handWorkOrderId}
              />
            }
            {handworkOrderAllDetailModal &&
              <HandWorkOrderAllDetailModel
                modal={handworkOrderAllDetailModal}
                toggle={handWoekAllOrderDetailtoggle}
                handWorkOrderId={handWorkOrderId}
              />
            }

            {handwWorkOrderModal &&
              <CreateHandWorkModel
                modal={handwWorkOrderModal}
                toggle={converHandWorkOrderToggle}
                HandWorkListApi={HandWorkOrderListApi}
                isEdit={false}
                editData={editData}
                designerId={designerId}
                handworkOrderId={handWorkOrderId}
                categoriesIds={categoriesIds}
              />
            }

            {updateEndDateTimeModal &&
              <StitchingStatusChangeWorkersEndTimeSetModel
                modal={updateEndDateTimeModal}
                toggle={updateEndDateTimeToggle}
                HandWorkId={handWorkId}
                HandWorkOrderListApi={HandWorkOrderListApi}
              />
            }

            <Modal
              isOpen={stitchingModal}
              toggle={stitchingOrderToggle}
              centered={true}
              size="defualt"
              style={{ width: !isMobile ? "600px" : "" }}
            >
              <div className="modal-content">
                <ModalHeader toggle={stitchingOrderToggle} tag="h5">
                  Stitching Order Detail
                </ModalHeader>
                <ModalBody>
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    onReset={e => {
                      e.preventDefault
                      setStitchingMasterId(0)
                      setStitchingWorkerId(0)
                      validation.handleReset()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={5}>
                        <FormGroup className="mb-2">
                          <Label
                            htmlFor="validationCustom03"
                            className="required"
                          >
                            Stitching Master
                          </Label>
                          <Select
                            unstyled
                            styles={isStitchingMasterSelected ? colourStyles1 : colourStyles}
                            value={stitchingMasterId}
                            onChange={(e) => {
                              setStitchingMasterId(e)
                              setIsStitchingMasterSelected(false)
                            }}
                            options={stitchingMasters}
                            className="select2-selection"
                          />
                          {isStitchingMasterSelected ? (
                            <div className="name-required">
                              {"Master is Required"}
                            </div>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md={5}>
                        <FormGroup className="mb-2">
                          <Label
                            htmlFor="validationCustom03"
                            className="required"
                          >
                            Stitching Worker
                          </Label>
                          <Select
                            unstyled
                            styles={isStitchingWorkerSelected ? colourStyles1 : colourStyles}
                            value={stitchingWorkerId}
                            onChange={(e) => {
                              setStitchingWorkerId(e)
                              setIsStitchingWorkerSelected(false)
                            }}
                            options={stitchingWorkers}
                            className="select2-selection"
                          />
                          {isStitchingWorkerSelected ? (
                            <div className="name-required">
                              {"Worker is Required"}
                            </div>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md={2}>
                        <FormGroup className="mb-2">
                          <Label htmlFor="validationCustom03" className="required">
                            Costing
                          </Label>
                          <Input
                            name="Costing"
                            placeholder="Cost"
                            type="text"
                            rows={4}
                            className="form-control-sm"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            onKeyPress={handleKeyPress}
                            value={validation.values.Costing}
                            invalid={
                              validation.touched.Costing && validation.errors.Costing
                                ? true
                                : false
                            }
                          />
                          {validation.touched.Costing && validation.errors.Costing ? (
                            <FormFeedback type="invalid">
                              {validation.errors.Costing}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <FormGroup className="mb-2">
                          <Label htmlFor="validationCustom03" className="">
                            Stuff Details
                          </Label>
                          <Input
                            name="StuffDetails"
                            placeholder="Enter detail"
                            type="textarea"
                            rows={4}
                            className="form-control-sm"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.StuffDetails}
                            invalid={
                              validation.touched.StuffDetails && validation.errors.StuffDetails
                                ? true
                                : false
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <div className="text-end">
                      {isEdit ? (
                        <Button
                          user="secondary"
                          className="btn btn-primary me-2 btn-sm "
                          onClick={handleCancle}
                        >
                          Cancle
                        </Button>
                      ) : (
                        <Button
                          user="secondary"
                          className="btn btn-primary me-2 btn-sm "
                          type="reset"
                        >
                          Reset
                        </Button>
                      )}
                      {formSumitLoading ? (
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          color="secondary"
                        >
                          <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                          Loading
                        </button>
                      ) : (
                        <Button
                          user="primary"
                          className="btn btn-primary btn-sm "
                          type="submit"
                          color="primary"
                        >
                          Submit
                        </Button>
                      )}
                    </div>
                  </Form>
                </ModalBody>
              </div>
            </Modal>

            <Modal
              isOpen={uploadImagesModal}
              toggle={uploadImagesOrderToggle}
              centered={true}
              size="defualt"
              style={{ width: !isMobile ? "600px" : "" }}
            >
              <div className="modal-content">
                <ModalHeader toggle={uploadImagesOrderToggle} tag="h5">
                  Upload Images
                </ModalHeader>
                <ModalBody>
                  <Form>

                    <Row>
                      <Label
                        htmlFor=""
                        className=""
                      >
                        Images
                      </Label>
                      <div>
                        <div className="d-flex">
                          <FormGroup>
                            <Dropzone onDrop={handleDrop} accept={{ "image/*": [] }} multiple>
                              {({ getRootProps, getInputProps }) => (
                                <div {...getRootProps()}>
                                  <input {...getInputProps()} />
                                  <div
                                    style={{
                                      cursor: "pointer",
                                      border: "2px dashed #0000004d",
                                      height: "130px",
                                      width: "115px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "3px",
                                    }}
                                  >
                                    <i className="bx bx-plus" style={{ fontSize: "24px" }}></i>
                                  </div>
                                </div>
                              )}
                            </Dropzone>
                          </FormGroup>
                        </div>
                      </div>
                    </Row>

                    <Row className="d-flex flex-wrap">
                      {images.map((item, index) => (
                        <Col md={3} key={index} className="mb-2">
                          <img
                            src={item}
                            alt={`preview-${index}`}
                            style={{
                              border: "1px solid #ced4da",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            height="130px"
                            width="115px"
                          />
                          <div
                            title="Remove"
                            style={{
                              position: "absolute",
                              top: "0",
                              left: "73%",
                              cursor: "pointer",
                            }}
                          >
                            <i
                              className="bx bx-x"
                              style={{
                                fontSize: "17px",
                                color: "black",
                                backgroundColor: "white",
                                border: "1px solid #8080806b",
                              }}
                              onClick={() => handleRemoveImage(item)}
                            />
                          </div>
                        </Col>
                      ))}
                    </Row>


                    <div className="text-end">
                      <Button
                        user="secondary"
                        className="btn btn-primary me-2 btn-sm "
                        onClick={() => UploadImageshandleCancle()}
                      >
                        Cancle
                      </Button>
                      {formSumitLoading ? (
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          color="secondary"
                        >
                          <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                          Loading
                        </button>
                      ) : (
                        <Button
                          user="primary"
                          className="btn btn-primary btn-sm "
                          type="button"
                          color="primary"
                          onClick={() => handleUploadImagesSubmit()}
                        >
                          Submit
                        </Button>
                      )}
                    </div>
                  </Form>
                </ModalBody>
              </div>
            </Modal>

            <Modal
              isOpen={viewImagesModal}
              toggle={viewImagesOrderToggle}
              centered={true}
              size="xl"
              style={{ width: !isMobile ? (images.length ? "900px" : "500px") : "" }}
            >
              <div className="modal-content">
                <ModalHeader toggle={viewImagesOrderToggle} tag="h5">
                  Images
                </ModalHeader>
                <ModalBody>
                  <Form>
                    <Row className="d-flex flex-wrap">
                      {images.length ?
                        <>
                          {images.map((item, index) => (
                            <Col md={3} key={index} className="mb-2">
                              <img
                                src={item}
                                alt={`preview-${index}`}
                                style={{
                                  border: "1px solid #ced4da",
                                  borderRadius: "3px",
                                  cursor: "pointer",
                                }}
                                height="180px"
                                width="175px"
                              />
                            </Col>
                          ))}
                        </>
                        :
                        <div style={{ display: "flex", justifyContent: "center", alignContent: "center", fontSize: "15px" }}>No Images</div>
                      }
                    </Row>
                  </Form>
                </ModalBody>
              </div>
            </Modal>

          </CardBody>
        </Card>
      </div>
    </div >
  )
}
HandWorkOrder.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
  onFilterChange: PropTypes.func,
}

export default HandWorkOrder
